import { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function useLandingContent(slug) {
  const [landing, setLanding] = useState(null);

  useEffect(() => {
    let isCurrent = true;

    fetch(`${API_URL}/api/landing/${slug}`)
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (isCurrent) {
          setLanding(data?.content || null);
        }
      })
      .catch(() => {
        if (isCurrent) {
          setLanding(null);
        }
      });

    return () => {
      isCurrent = false;
    };
  }, [slug]);

  return landing;
}